"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ShoppingBagCounter = require("./ShoppingBagCounter");
Object.keys(_ShoppingBagCounter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ShoppingBagCounter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShoppingBagCounter[key];
    }
  });
});
